import * as angular from 'angular';
import * as _ from 'lodash';

import { IUserService } from '../../services';
import { ApplicationUserViewModel } from '../../models';
import { Store } from '../Store';
import * as USERS from './users.constants';
import * as Actions from './users.actions';

export interface IUserActionsService {
    getAll(): (dispatch: any, getState: () => Store) => angular.IPromise<ApplicationUserViewModel[]>;
    getAll(force: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<ApplicationUserViewModel[]>;
    getOne(guid: string): (dispatch: any, getState: () => Store) => angular.IPromise<ApplicationUserViewModel>;
}

export class UserActionsService implements IUserActionsService {

    static serviceId = 'userActionsService';

    static $inject = [
        '$q',
        'userService'
    ];

    constructor(
        private _$q: angular.IQService,
        private _userService: IUserService
    ) {
    }

    getOne(guid: string) {
        return (dispatch: any, getState: () => Store) => {
            const { users } = getState();
            if (!users.isLoading && !users.isLoaded) {
                dispatch(Actions.loadUsers());
                return this._userService
                    .getAllUserModelsWithDetails(true, false)
                    .then(data => {
                        const userIdList = data.map(user => user.guid);
                        return this._userService
                            .getPictures(userIdList)
                            .then(pictures => {
                                const result = this._userService.mapUsers(data.filter(c => c.guid === guid), pictures);
                                dispatch(Actions.loadUsersSuccess(result));
                                return result;
                            })
                            .catch((reason) => {
                                dispatch(Actions.loadUsersError(reason));
                                return reason;
                            });
                    })
                    .catch((reason) => {
                        dispatch(Actions.loadUsersError(reason));
                        return reason;
                    });
            } else {
                return this._$q.when(_.find(_.values<ApplicationUserViewModel>(users.dictionary), c => c.guid === guid));
            }
        };
    }

    getAll();
    getAll(force: boolean);
    getAll(force?: boolean) {
        return (dispatch: any, getState: () => Store) => {
            const { users } = getState();
            if (force || (!users.isLoading && !users.isLoaded)) {
                dispatch(Actions.loadUsers());
                return this._userService
                    .getAllUserModelsWithDetails(true, false)
                    .then(data => {
                        const userIdList = data.map(user => user.guid);
                        return this._userService
                            .getPictures(userIdList)
                            .then(pictures => {
                                const result = this._userService.mapUsers(data, pictures);
                                dispatch(Actions.loadUsersSuccess(result));
                                return result;
                            })
                            .catch((reason) => {
                                dispatch(Actions.loadUsersError(reason));
                                return reason;
                            });
                    })
                    .catch((reason) => {
                        dispatch(Actions.loadUsersError(reason));
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<ApplicationUserViewModel>(users.dictionary));
            }
        };
    }
}